//Logo
import redroadicon from './images/logo/redroadicon.svg'
import redroadwhitelogo from './images/logo/redroadwhitelogo.svg'

//Data
import { Pages, Permissions } from './data/PagesPermissions'
import { workAllocationHeaders, workAllocationImportErrors } from './data/BulkUploadTemplateHeader'

const assets = {
    redroadicon,
    redroadwhitelogo,
    data: {
        Pages,
        Permissions,
        workAllocationHeaders,
        workAllocationImportErrors,
    },
}

export default assets
